import { render, staticRenderFns } from "./LoadingProfilePage.vue?vue&type=template&id=b826354e&"
import script from "./LoadingProfilePage.vue?vue&type=script&lang=ts&"
export * from "./LoadingProfilePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports